import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
  public appName = environment.appName;
  public url= environment.serverUrl;

  constructor(private http:HttpClient) {
  }

  uploadFiles(file:File,id:string){

    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);

     return this.http.post(this.url+"fileUpload.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }

  uploadFilesPesosPitufo(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);

     return this.http.post(this.url+"fileUploadPesosPitufo.php",formData,{ headers:headers }).pipe(map(data=>{
      return data;
    }));
  }

  uploadFilesPesosGirsac(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);

     return this.http.post(this.url+"fileUploadPesosGirsac.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }

  uploadFilesCamionesAlbaran(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);

     return this.http.post(this.url+"fileUploadCamiones.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }

  uploadFilesCuadernoCampo(file:File,id:string){
    let headers=new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id',id);
    //console.log(file.name);

     return this.http.post(this.url+"fileupload/fileUploadCuaderno.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }

  // uploadFilesgeneric(file: File , id: string, folder: string ,database: string, field: string){

  //   console.log(file, id, folder, database, field )

  //   let headers = new HttpHeaders();
  //   headers.append('Content-Type', 'multipart/form-data');
  //  // headers.append('Content-Type','application/json');

  //   let formData:FormData = new FormData();
  //   formData.append('fileToUpload', file, file.name);
  //   formData.append('id', id);
  //   formData.append('folder', folder);
  //   formData.append('database', database);
  //   formData.append('field', field);
  //   //console.log(file.name);

  //    return this.http.post(this.url + "fileupload/fileUploadGeneric.php",formData,{headers:headers}).pipe(map(data=>{
  //     return data;
  //   }));
  // }
  deleteFilesGeneric( id: string, folder: string ,database: string, field: string){
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();

    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    //console.log(file.name);

     return this.http.post(this.url + "fileupload/fileDeleteGeneric.php",formData,{headers:headers}).pipe(map(data=>{
      return data;
    }));
  }

  /**
   *
   * Que tipo es
   *
   * @param {File} file
   * @param {string} id
   * @param {string} folder
   * @param {string} database
   * @param {string} field
   * @param {string} tipo
   * @returns
   * @memberof UploadService
   */
  uploadFilesFrutoHueso(file: File , id: string, folder: string ,database: string, field: string, tipo: string) {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
   // headers.append('Content-Type','application/json');

    let formData:FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);
    formData.append('tipo', tipo);
    //console.log(file.name);

     return this.http.post(this.url + "fileupload/fileUploadGenericFrutos.php", formData, {headers:headers}).pipe(map(data=>{
      return data;
    }));
  }


  uploadFilesgeneric(file: File , id: string, folder: string ,database: string, field: string){

    console.log(file, id, folder, database, field )

    const formData: FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);

    return this.http.post(this.url + "fileupload/uploadImgResized.php", formData).pipe(
      catchError(this.handleError)
    );
  }

  uploadFiles123(file: File, id: string, folder: string, database: string, field: string, maxWidth: number, maxHeight: number): Observable<any> {

    return new Observable(observer => {
      this.resizeImage(file, maxWidth, maxHeight, (blob) => {
        let formData = new FormData();
        formData.append('fileToUpload', blob, file.name);
        formData.append('id', id);
        formData.append('folder', folder);
        formData.append('database', database);
        formData.append('field', field);

        let headers = new HttpHeaders();
        headers.append('Content-Type', 'multipart/form-data');

        this.http.post(this.url + "fileupload/fileUploadGeneric.php", formData, { headers: headers }).pipe(
          map(data => {
            return data;
          })
        ).subscribe(
          data => {
            observer.next(data);
            observer.complete();
          },
          error => {
            observer.error(error);
          }
        );
      });
    });
  }

  private resizeImage(file: File, maxWidth: number, maxHeight: number, callback: (blob: Blob) => void) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        const extension = file.name.split('.').pop().toLowerCase();
        let format = 'image/jpeg', quality = 0.7;
        if (extension === 'png') {
          format = 'image/png';
          quality = 0.7;
        } else if (extension === 'jpeg' || extension === 'jpg') {
          format = 'image/jpeg';
          quality = 0.7;
        }

        canvas.toBlob(blob => callback(blob), format, quality);
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  }


  uploadFileResize(file: File, id: string, folder: string, database: string, field: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('fileToUpload', file, file.name);
    formData.append('id', id);
    formData.append('folder', folder);
    formData.append('database', database);
    formData.append('field', field);

    return this.http.post(this.url + "fileupload/uploadImgResized.php", formData).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }


}
